import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryDeliveryInfoColumn } from '../constants/dictionary-delivery-columns.constant';

export const generateDeliveryColumns = () => {
	return [
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].region,
			dataIndex: 'region',
			key: 'region',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].commune,
			dataIndex: 'commune',
			key: 'commune',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].address,
			dataIndex: 'address',
			key: 'address',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].floor,
			dataIndex: 'number_dpto_house',
			key: 'number_dpto_house',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].hometype,
			dataIndex: 'type_house',
			key: 'type_house',
		},
		{
			title: dictionaryDeliveryInfoColumn[Enviroment.LANGUAGE].reference,
			dataIndex: 'reference',
			key: 'reference',
		},
	];
};
